import * as React from 'react';

// PACKAGES
import Moment from 'react-moment';

// TYPES
interface DisplayTimeFromNowTypes {
	children?: string | number | Date | moment.Moment;
}

export const DisplayTimeFromNow: React.FC<DisplayTimeFromNowTypes> = ({ children }) => {
	return (
		<Moment fromNow parse="YYYY-MM-DDTHH:mm:ss.SSSSSSSZ">
			{children}
		</Moment>
	);
};

export default DisplayTimeFromNow;
